// removed by extract-text-webpack-plugin
module.exports = {"block":"IJoCWLdO9sRThiZgEfXi7","innerBlock":"UMkRZ2ZHbNjyJMs0XfOF9","image":"_2PLUkAyWdRp_vMYjlL7nPl","text":"_2GFMtxRAnKTMR4dmDoYze2","readmore":"s7lNlKOG4sy00oXqvnpYQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HMSSlide/HMSSlide.module.scss
// module id = 774
// module chunks = 0